require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-tags-coralis-jordan.json") })
        }
      }, "path---es-articles-tags-coralis-jordan");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-tags-coralis-jordan!./.cache/json/es-articles-tags-coralis-jordan.json
// module id = 2250
// module chunks = 231608221292675